/*
 * @Author: Tahiti
 * @Date: 2025-12-10 18:48:29
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-11 13:38:12
 * @Description:
 * @FilePath: /weryai-web/locales/modules/profiles.ts
 */
export default {
    zh: {
        email: '邮箱',
        avatar: '头像',
        nick_name: '昵称',
        submit: '提交',
        submitting: '提交中',
        editAvatar: '编辑头像',
        submitSuccess: '修改成功',
        tip: '提示',
        cancel: '取消',
        confirm: '确定',
    },
    en: {
        email: 'Email',
        avatar: 'Avatar',
        nick_name: 'Nick Name',
        submit: 'Submit',
        submitting: 'Submitting',
        editAvatar: 'Edit Avatar',
        submitSuccess: 'Submit Success',
        tip: 'Tip',
        cancel: 'Cancel',
        confirm: 'Confirm',
    },
    ja: {
        email: 'メールアドレス',
        avatar: 'アバター',
        nick_name: 'ニックネーム',
        submit: '送信',
        submitting: '送信中',
        editAvatar: 'アバターを編集',
        submitSuccess: '送信成功',
        tip: '提示',
        cancel: 'キャンセル',
        confirm: '確認',
    },
    ko: {
        email: '이메일',
        avatar: '아바타',
        nick_name: '닉네임',
        submit: '제출',
        submitting: '제출중',
        editAvatar: '아바타 수정',
        submitSuccess: '제출 성공',
        tip: '팁',
            cancel: '', // Pending alignment
            confirm: '', // Pending alignment
    },
    tw: {
        email: '信箱',
        avatar: '頭像',
        nick_name: '暱稱',
        submit: '提交',
        submitting: '提交中',
        editAvatar: '編輯頭像',
        submitSuccess: '修改成功',
        tip: '提示',
        cancel: '取消',
        confirm: '確定',
    },
    pl: {
        email: 'E-mail',
        avatar: 'Avatar',
        nick_name: 'Nazwa użytkownika',
        submit: 'Zapisz',
        submitting: 'Zapisywanie...',
        editAvatar: 'Edytuj avatar',
        submitSuccess: 'Zapisano',
        tip: 'Wskazówka',
        cancel: 'Anuluj',
        confirm: 'Potwierdź',
    },
    es: {
        email: 'Correo electrónico',
        avatar: 'Avatar',
        nick_name: 'Nickname',
        submit: 'Enviar',
        submitting: 'Enviando',
        editAvatar: 'Editar Avatar',
        submitSuccess: 'Enviar exitosamente',
        tip: 'Sugerencia',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
    },
    fr: {
        email: 'Email',
        avatar: 'Avatar',
        nick_name: 'Nickname',
        submit: 'Envoyer',
        submitting: 'Envoi en cours',
        editAvatar: 'Modifier Avatar',
        submitSuccess: 'Envoyer avec succès',
        tip: 'Suggestion',
        cancel: 'Annuler',
        confirm: 'Confirmer',
    },
    de: {
        email: 'Email',
        avatar: 'Avatar',
        nick_name: 'Nickname',
        submit: 'Absenden',
        submitting: 'Absenden in Progress',
        editAvatar: 'Avatar bearbeiten',
        submitSuccess: 'Absenden erfolgreich',
        tip: 'Tip',
        cancel: 'Abbrechen',
        confirm: 'Bestätigen',
    },
    ru: {
        email: 'Email',
        avatar: 'Avatar',
        nick_name: 'Nickname',
        submit: 'Отправить',
        submitting: 'Отправка в процессе',
        editAvatar: 'Изменить аватар',
        submitSuccess: 'Отправить успешно',
        tip: 'Подсказка',
        cancel: 'Отмена',
        confirm: 'Подтвердить',
    },
    pt: {
        email: 'Email',
        avatar: 'Avatar',
        nick_name: 'Nickname',
        submit: 'Enviar',
        submitting: 'Envio em andamento',
        editAvatar: 'Editar Avatar',
        submitSuccess: 'Enviar com sucesso',
        tip: 'Sugestão',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
    },
    it: {
        email: 'Email',
        avatar: 'Avatar',
        nick_name: 'Nickname',
        submit: 'Invia',
        submitting: 'Invio in corso',
        editAvatar: 'Modifica Avatar',
        submitSuccess: 'Inviare con successo',
        tip: 'Suggerimento',
        cancel: 'Annulla',
        confirm: 'Conferma',
    },
    ar: {
        email: 'البريد الإلكتروني',
        avatar: 'الأيقونة',
        nick_name: 'اسم المستخدم',
        submit: 'إرسال',
        submitting: 'جارٍ الإرسال',
        editAvatar: 'تعديل الأيقونة',
        submitSuccess: 'تم الإرسال بنجاح',
        tip: 'تلميح',
        cancel: 'إلغاء',
        confirm: 'تأكيد',
        },
    th: {
        email: 'อีเมล',
        avatar: 'อวาตาร์',
        nick_name: 'ชื่อเล่น',
        submit: 'ส่ง',
        submitting: 'กำลังส่ง',
        editAvatar: 'แก้ไขอวาตาร์',
        submitSuccess: 'ส่งสำเร็จ',
        tip: 'คำแนะนำ',
        cancel: 'ยกเลิก',
        confirm: 'ยืนยัน',
        },
    da: {
        email: 'Email',
        avatar: 'Avatar',
        nick_name: 'Kaldenavn',
        submit: 'Send',
        submitting: 'Sender...',
        editAvatar: 'Rediger avatar',
        submitSuccess: 'Sendt',
        tip: 'Tip',
        cancel: 'Annuller',
        confirm: 'Bekræft',
        },
    no: {
        email: 'E-post',
        avatar: 'Avatar',
        nick_name: 'Kallenavn',
        submit: 'Send',
        submitting: 'Sender...',
        editAvatar: 'Rediger avatar',
        submitSuccess: 'Sendt',
        tip: 'Tips',
        cancel: 'Avbryt',
        confirm: 'Bekreft',
        },
    nl: {
        email: 'E-mail',
        avatar: 'Avatar',
        nick_name: 'Bijnaam',
        submit: 'Verzenden',
        submitting: 'Bezig met verzenden...',
        editAvatar: 'Avatar bewerken',
        submitSuccess: 'Verzonden',
        tip: 'Tip',
        cancel: 'Annuleren',
        confirm: 'Bevestigen',
        },
    id: {
        email: 'Email',
        avatar: 'Avatar',
        nick_name: 'Nama panggilan',
        submit: 'Kirim',
        submitting: 'Mengirim...',
        editAvatar: 'Edit avatar',
        submitSuccess: 'Berhasil dikirim',
        tip: 'Tips',
        cancel: 'Batal',
        confirm: 'Konfirmasi',
        },
    tr: {
        email: 'E-posta',
        avatar: 'Avatar',
        nick_name: 'Takma ad',
        submit: 'Gönder',
        submitting: 'Gönderiliyor...',
        editAvatar: 'Avatarı düzenle',
        submitSuccess: 'Gönderildi',
        tip: 'İpucu',
        cancel: 'İptal',
        confirm: 'Onayla',
    },
}
